import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sort-relevance',
  templateUrl: './icon-sort-relevance.component.html',
  styleUrls: ['./icon-sort-relevance.component.scss']
})
export class IconSortRelevanceComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
